export const FETCH_COMMISSIONS_START = 'FETCH_COMMISSIONS_START';
export const FETCH_COMMISSIONS_SUCCESS = 'FETCH_COMMISSIONS_SUCCESS';
export const FETCH_COMMISSIONS_ERROR = 'FETCH_COMMISSIONS_ERROR';

export default {
  FETCH_COMMISSIONS_START,
  FETCH_COMMISSIONS_SUCCESS,
  FETCH_COMMISSIONS_ERROR,
};
